/* eslint-disable i18next/no-literal-string -- TanStack cache key segments */
export interface ContentTestsListKeyParams {
  page?: number;
  pageSize?: number;
}

export const CONTENT_TEST_QUERY_KEYS = {
  all: (workspaceId: string) => ['content-tests', workspaceId] as const,
  list: (workspaceId: string, params: ContentTestsListKeyParams = {}) =>
    [...CONTENT_TEST_QUERY_KEYS.all(workspaceId), 'list', params] as const,
  detail: (id: string) => ['content-tests', 'detail', id] as const,
  /**
   * Deep-link resolution of a content-test id to its owning workspace/org.
   * Extends the detail tuple so a detail invalidation also re-resolves.
   */
  resolution: (id: string) => [...CONTENT_TEST_QUERY_KEYS.detail(id), 'resolution'] as const,
} as const;
